var React = require('react');

function Help (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M3,4.5h2.5c0.1-1.4,1-2.3,2.4-2.3s2.3,0.9,2.3,2.1c0,1-0.5,1.6-1.8,2.4c-1.5,0.9-2.1,1.8-2.1,3.4v0.8H9v-0.6\n\tc0-1.1,0.3-1.7,1.7-2.5C12.2,6.9,13,5.7,13,4.1C13,1.7,11,0,8.1,0C4.9,0,3.1,1.8,3,4.5z M7.8,16c1.1,0,1.7-0.7,1.7-1.7\n\tc0-1.1-0.7-1.7-1.7-1.7c-1.1,0-1.8,0.7-1.8,1.7S6.7,16,7.8,16z","fill":"currentColor"}));
}

Help.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Help;

Help.default = Help;
